/**
 * 获取元素计算后样式（无框架依赖）
 */
export function getElementStyle({ elementTarget = document.body, styleProp = "" }: any = {}) {
  let targetElement: HTMLElement | null;

  if (typeof elementTarget === "string") {
    targetElement = document.querySelector(elementTarget);
    if (!targetElement) {
      console.warn(`未找到元素：${elementTarget}`);
      return "";
    }
  } else if (elementTarget instanceof HTMLElement) {
    targetElement = elementTarget;
  } else {
    targetElement = document.body;
  }

  // 短横线转驼峰
  const camelProp = styleProp.replace(/-([a-z])/g, (_: any, l: string) => l.toUpperCase());

  if (window.getComputedStyle) {
    const style = window.getComputedStyle(targetElement);
    return style.getPropertyValue(styleProp) || (style as any)[camelProp] || "";
  }

  return (targetElement as any).currentStyle?.[camelProp] || "";
}
